import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';

import SingleJob from '../../components/Job';

import jobImg1 from '../../assets/img/blog/blog-1.jpg';
import jobImg2 from '../../assets/img/blog/blog-2.jpg';
import jobImg3 from '../../assets/img/blog/blog-3.jpg';
import jobImg4 from '../../assets/img/blog/blog-4.jpg';
import jobImg5 from '../../assets/img/blog/blog-5.jpg';
import jobImg6 from '../../assets/img/blog/blog-6.jpg';
import Brand from '../../components/Brand';

const JobMain = () => {
  return (
    <main>
      <Breadcrumb pageTitle="Job" />

      <div className="job__area job__plr mt-110">
        <div className="container-fluid">
          <div className="row">
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <SingleJob Image={jobImg1} />
            </div>
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".4s"
            >
              <SingleJob Image={jobImg2} />
            </div>
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <SingleJob Image={jobImg3} />
            </div>
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".6s"
            >
              <SingleJob Image={jobImg4} />
            </div>
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <SingleJob Image={jobImg5} />
            </div>
            <div
              className="col-xl-4 col-lg-6 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".8s"
            >
              <SingleJob Image={jobImg6} />
            </div>
          </div>
        </div>
      </div>

      <Brand itemClass="brand-2__area brand-2__space" />
    </main>
  );
};

export default JobMain;
